export const GET_DOCUMENTS_NEXT_NUMBER = 'GET_DOCUMENTS_NEXT_NUMBER';
export const GET_DOCUMENTS_NEXT_NUMBER_SUCCESS = 'GET_DOCUMENTS_NEXT_NUMBER_SUCCESS';
export const GET_DOCUMENTS_NEXT_NUMBER_FAIL = 'GET_DOCUMENTS_NEXT_NUMBER_FAIL';

export const DEL_DOCUMENTS_NEXT_NUMBER = 'DEL_DOCUMENTS_NEXT_NUMBER';

export const GET_ACTS_BY_DOCTYPE = 'GET_ACTS_BY_DOCTYPE';
export const GET_ACTS_BY_DOCTYPE_SUCCESS = 'GET_ACTS_BY_DOCTYPE_SUCCESS';
export const GET_ACTS_BY_DOCTYPE_FAIL = 'GET_ACTS_BY_DOCTYPE_FAIL';

export const GET_ACTS_BY_STOCK = 'GET_ACTS_BY_STOCK';
export const GET_ACTS_BY_STOCK_SUCCESS = 'GET_ACTS_BY_STOCK_SUCCESS';
export const GET_ACTS_BY_STOCK_FAIL = 'GET_ACTS_BY_STOCK_FAIL';

export const GET_PIECES_BY_ACT = 'GET_PIECES_BY_ACT';
export const GET_PIECES_BY_ACT_SUCCESS = 'GET_PIECES_BY_ACT_SUCCESS';
export const GET_PIECES_BY_ACT_FAIL = 'GET_PIECES_BY_ACT_FAIL';

export const GET_PIECES_BY_STOCK = 'GET_PIECES_BY_STOCK';
export const GET_PIECES_BY_STOCK_SUCCESS = 'GET_PIECES_BY_STOCK_SUCCESS';
export const GET_PIECES_BY_STOCK_FAIL = 'GET_PIECES_BY_STOCK_FAIL';

export const ADD_PIECE_TO_ACT = 'ADD_PIECE_TO_ACT';
export const ADD_PIECE_TO_ACT_SUCCESS = 'ADD_PIECE_TO_ACT_SUCCESS';
export const ADD_PIECE_TO_ACT_FAIL = 'ADD_PIECE_TO_ACT_FAIL';
export const ADD_PIECE_TO_ACT_CLEAR = 'ADD_PIECE_TO_ACT_CLEAR';

export const DELETE_PIECE_FROM_ACT = 'DELETE_PIECE_FROM_ACT';
export const DELETE_PIECE_FROM_ACT_SUCCESS = 'DELETE_PIECE_FROM_ACT_SUCCESS';
export const DELETE_PIECE_FROM_ACT_FAIL = 'DELETE_PIECE_FROM_ACT_FAIL';
export const DELETE_PIECE_FROM_ACT_CLEAR = 'DELETE_PIECE_FROM_ACT_CLEAR';

export const UPDATE_ACT = 'UPDATE_ACT';
export const UPDATE_ACT_SUCCESS = 'UPDATE_ACT_SUCCESS';
export const UPDATE_ACT_FAIL = 'UPDATE_ACT_FAIL';
export const UPDATE_ACT_CLEAR = 'UPDATE_ACT_CLEAR';

export const DELETE_ACT = 'DELETE_ACT';
export const DELETE_ACT_SUCCESS = 'DELETE_ACT_SUCCESS';
export const DELETE_ACT_FAIL = 'DELETE_ACT_FAIL';
export const DELETE_ACT_CLEAR = 'DELETE_ACT_CLEAR';

export const GET_ADMIN_ACT_UPDATE = 'GET_ADMIN_ACT_UPDATE';

export const GET_HOLDER_REPORTS_BY_STOCK = 'GET_HOLDER_REPORTS_BY_STOCK';
export const GET_HOLDER_REPORTS_BY_STOCK_SUCCESS = 'GET_HOLDER_REPORTS_BY_STOCK_SUCCESS';
export const GET_HOLDER_REPORTS_BY_STOCK_FAIL = 'GET_HOLDER_REPORTS_BY_STOCK_FAIL';
export const DELETE_HOLDER_REPORT = 'DELETE_HOLDER_REPORT';
export const DELETE_HOLDER_REPORT_SUCCESS = 'DELETE_HOLDER_REPORT_SUCCESS';
export const DELETE_HOLDER_REPORT_FAIL = 'DELETE_HOLDER_REPORT_FAIL';

export const SIGN_ACTS_BY_CLIENT = 'SIGN_ACTS_BY_CLIENT';
export const SIGN_ACTS_BY_CLIENT_SUCCESS = 'SIGN_ACTS_BY_CLIENT_SUCCESS';
export const SIGN_ACTS_BY_CLIENT_FAIL = 'SIGN_ACTS_BY_CLIENT_FAIL';
export const SET_INITIAL_STATE_ACTS = 'SET_INITIAL_STATE_ACTS';

export const SET_VISIBLE_POPUP_SIGN_SELECTED = 'SET_VISIBLE_POPUP_SIGN_SELECTED';

export const SET_SELECTED_DOC_ITEMS = 'SET_SELECTED_DOC_ITEMS';
